import { gql, gqlClient } from "@/services/gql";

export class EmbeddedPlayerLoader {
  static async getVideoPlaylist(userId) {
    let data;
    let videoPlaylistId = new URLSearchParams(window.location.search).get('playlist_id');

    if (videoPlaylistId) {
      data = await this.viaVideoPlaylistId(videoPlaylistId);
    }

    if (!data && userId) {
      data = await this.viaUserId(userId);
    }

    return data;
  }

  static async viaVideoPlaylistId(videoPlaylistId) {
    const query = gql`
        query {
            videoPlaylists(id: ${videoPlaylistId}) {
                id
                embedUrl
            }
        }
    `;

    const response = await gqlClient.query(query);

    return response.videoPlaylists[0];
  }

  static async viaUserId(userId) {
    const query = gql`
        query {
            videoPlaylists(
                where: {
                    AND: [
                        { column: USER_ID, operator: EQ, value: ${userId} }
                        { column: IS_PINNED, operator: EQ, value: true }
                        { column: PUBLISHED_AT, operator: NEQ, value: NULL }
                    ]
                }
            ) {
                id
                name
                publishedAt
                embedUrl
                createdAt
            }
        }
    `;

    const response = await gqlClient.query(query);

    return response.videoPlaylists[0];
  }
}